import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

/** A 404 that offers a way forward instead of a dead end. */
export function NotFoundPage(): React.ReactNode {
  const { t } = useTranslation();

  return (
    <div className="mx-auto max-w-xl px-4 py-20 text-center">
      <p className="text-5xl font-extrabold text-[var(--color-muted-fg)]">404</p>
      <h1 className="mt-4 text-xl font-bold">{t('notFound.title')}</h1>
      <p className="mt-2 text-sm text-[var(--color-muted-fg)]">{t('notFound.body')}</p>
      <Link
        to="/"
        className="mt-6 inline-block rounded-[var(--radius-control)] bg-brand-700 px-4 py-2 text-sm font-semibold text-white hover:bg-brand-800"
      >
        {t('notFound.home')}
      </Link>
    </div>
  );
}
